import prettyBytes from 'pretty-bytes'

export const formatBytes = (bytes: number) => {
  return prettyBytes(bytes)
}
